export const START_EVENTS = new Set(['start', 'assistant_start', 'meeting_notes_start']);
export const TOKEN_EVENTS = new Set(['token', 'assistant_token', 'meeting_notes_token']);
export const COMPLETE_EVENTS = new Set(['complete', 'assistant_complete', 'meeting_notes_complete']);
export const ERROR_EVENTS = new Set(['error', 'assistant_error', 'meeting_notes_error']);
export const DONE_EVENTS = new Set(['done', 'assistant_done', 'meeting_notes_done']);
